module.exports = __webpack_public_path__ + "static/media/doctor-2.919b6129.png";